import React from 'react';
import { Trash2, FileText, Edit, CheckCircle, ExternalLink } from 'lucide-react';

export default function LibraryAdminList({ items, onDelete, onEdit, onApprove }) {
  
  const handleDeleteClick = (item) => {
    if (window.confirm(`Excluir "${item.title}"?`)) {
        if (onDelete) onDelete(item.id);
    }
  };

  if (!items || items.length === 0) {
    return (
        <div className="p-8 text-center bg-gray-50 border border-dashed border-gray-300 rounded-xl">
            <p className="text-gray-400 text-sm">Nenhum documento nesta lista.</p>
        </div>
    );
  }

  return (
    <div className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
      <table className="w-full text-left border-collapse">
        <thead>
          <tr className="bg-gray-50 border-b border-gray-200 text-[10px] font-bold text-gray-500 uppercase tracking-widest">
            <th className="p-4 w-12 text-center">#</th>
            <th className="p-4">Documento</th>
            <th className="p-4 w-40">Autor / Relator</th>
            <th className="p-4 w-20 text-center">Ano</th>
            <th className="p-4 w-32 text-center">Ações</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {items.map((item) => (
            <tr key={item.id} className="hover:bg-blue-50/30 transition-colors group">
              <td className="p-4 text-center">
                <div className={`w-8 h-8 rounded-lg flex items-center justify-center mx-auto ${item.status === 'PENDING_REVIEW' ? 'bg-yellow-100 text-yellow-600' : 'bg-gray-100 text-gray-500'}`}>
                    <FileText className="w-4 h-4" />
                </div>
              </td>
              <td className="p-4">
                <div className="font-bold text-gray-800 text-sm leading-snug line-clamp-2" title={item.title}>
                    {item.title}
                </div>
                <div className="flex gap-2 mt-1">
                    {item.status === 'PENDING_REVIEW' && (
                        <span className="text-[9px] font-bold bg-yellow-100 text-yellow-700 px-1.5 py-0.5 rounded uppercase">Triagem</span>
                    )}
                    <span className="text-[10px] text-gray-400 font-mono truncate max-w-[150px]">ID: {item.id}</span>
                </div>
              </td>
              <td className="p-4 text-xs text-gray-600 font-medium">
                {item.author || item.authorJurisdiction || '-'}
              </td>
              <td className="p-4 text-center text-xs font-bold text-gray-500 bg-gray-50/50 rounded-lg">
                {item.year || '-'}
              </td>
              <td className="p-4 text-center">
                <div className="flex items-center justify-center gap-1">
                    {item.status === 'PENDING_REVIEW' && onApprove && (
                        <button onClick={() => onApprove(item)} className="p-1.5 text-green-600 hover:bg-green-50 rounded" title="Aprovar">
                            <CheckCircle className="w-4 h-4" />
                        </button>
                    )}
                    <button onClick={() => onEdit(item)} className="p-1.5 text-blue-400 hover:text-blue-600 hover:bg-blue-50 rounded" title="Editar">
                        <Edit className="w-4 h-4" />
                    </button>
                    {item.mirror_url && (
                        <button onClick={() => window.open(item.mirror_url, '_blank')} className="p-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-50 rounded" title="Ver PDF">
                            <ExternalLink className="w-4 h-4" />
                        </button>
                    )}
                    <button onClick={() => handleDeleteClick(item)} className="p-1.5 text-red-400 hover:text-red-600 hover:bg-red-50 rounded" title="Excluir">
                        <Trash2 className="w-4 h-4" />
                    </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}